module.exports = __webpack_public_path__ + "static/media/googleIcon.55d3560e.png";